// extracted by mini-css-extract-plugin
export default {"wrapper":"WeatherBlock_wrapper__n3XSe","extra_margin":"WeatherBlock_extra_margin__PDYFJ","row":"WeatherBlock_row__e6-vk"};